export enum MenuActionTypes {
  ACTION_SET_OBRA = 'ACTION_SET_OBRA',
  ACTION_SET_OBRAS = 'ACTION_SET_OBRAS',
  ACTION_SET_CONTRATOS = 'ACTION_SET_CONTRATOS',
  ACTION_SET_CONTRATO = 'ACTION_SET_CONTRATO',
  MenuActionTypes = 'MenuActionTypes'
}
